import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from '../../extrastockOffers/style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import useExtraStocks from '../useExtraStocks';
import UIHelper from 'helpers/UIHelper';
import { Link, useLocation } from 'react-router-dom';
import FormHelper from 'helpers/FormHelper';
import NotificationFormForEdit from '../../../../../components/modules/notificationFormForEdit';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const {
    form,
    shoppingCenters,
    extrastockType,
    handleCreateOrUpdate,
    updateInProcess,
  } = useExtraStocks(false, !isNew);
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('CREARE EXTRASTOCK') : t('MODIFICA ANNUNCIO');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            square: '',
            rent_price: '',
            consumption_price: '',
            comments: '',
            shopping_center_id: '',
            extrastock_type: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <InfoSection
            shoppingCenters={shoppingCenters}
            extrastockType={extrastockType}
          />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
